import type { OnboardingTemplateStep } from 'src/interfaces/onboardingTemplate'
import { normalizeCollectDataTemplateConfigId } from 'src/utils/collectDataTemplateEditor/configIds'
import type { FlowEditorTemplateDocument } from './types'

/** Flat editor steps for existing UI; sorted by global config order then step order. */
export function documentToEditorSteps(
  document: FlowEditorTemplateDocument,
): OnboardingTemplateStep[] {
  const steps: OnboardingTemplateStep[] = []

  const sortedConfigIds = [...document.configLocalIds].sort((a, b) => {
    const orderA = document.configsByLocalId[a]?.order ?? 0
    const orderB = document.configsByLocalId[b]?.order ?? 0

    return orderA - orderB
  })

  for (const configLocalId of sortedConfigIds) {
    const config = document.configsByLocalId[configLocalId]

    if (!config) {
      continue
    }

    const stepIds = [...config.stepLocalIds].sort((a, b) => {
      const orderA = document.stepsByLocalId[a]?.order ?? 0
      const orderB = document.stepsByLocalId[b]?.order ?? 0

      return orderA - orderB
    })

    for (const stepLocalId of stepIds) {
      const step = document.stepsByLocalId[stepLocalId]

      if (!step) {
        continue
      }

      steps.push({
        id: step.localId,
        type: step.type,
        order: step.order,
        retroactiveCollectRequired: step.retroactiveCollectRequired,
        ignoreMonitoring: step.ignoreMonitoring,
        recollectSameTypeSteps: step.recollectSameTypeSteps,
        skipRetroactiveCollectIfAnySameTypeCompleted:
          step.skipRetroactiveCollectIfAnySameTypeCompleted,
        collectDataTemplateStepsConfigId: normalizeCollectDataTemplateConfigId(configLocalId),
        collectDataTemplateStepLabel: step.collectDataTemplateStepLabel,
        config: step.config,
      })
    }
  }

  return steps
}

export function documentToEmptyGroupUiIds(document: FlowEditorTemplateDocument): string[] {
  const empty: string[] = []

  for (const configLocalId of document.configLocalIds) {
    const config = document.configsByLocalId[configLocalId]

    if (config && config.stepLocalIds.length === 0) {
      empty.push(configLocalId)
    }
  }

  return empty
}
